/* eslint-disable */
import React, { useCallback } from 'react';
import { PAGE_SIZE, NAT_TYPE_MAP } from '../config/pars';
import { ListView } from 'antd-mobile';
import styles from '../styles/apply.less';

const renderProvince = realTimeObj => {
  let dom = '--';
  if (realTimeObj && realTimeObj.baseinfo && realTimeObj.baseinfo.prov_text) {
    dom = realTimeObj.baseinfo.prov_text;
  }
  return dom;
};

const renderIsp = realTimeObj => {
  let dom = '--';
  if (realTimeObj && realTimeObj.baseinfo && realTimeObj.baseinfo.isp_text) {
    dom = realTimeObj.baseinfo.isp_text;
  }
  return dom;
};

const renderNat = realTimeObj => {
  let dom = '--';
  if (realTimeObj && realTimeObj.netinfo && realTimeObj.netinfo.nat_udp_nat) {
    let natFormat = Number(realTimeObj.netinfo.nat_udp_nat);
    dom = NAT_TYPE_MAP[natFormat];
  }
  return dom;
};

const DeviceList = ({
  list,
  getList,
  handleItemClick,
  loading = false,
  pageSize = PAGE_SIZE,
  allowPagination = true,
  choosen = true,
}) => {
  let dataSource = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
  dataSource = dataSource.cloneWithRows(list);

  const row = useCallback((item, sectionID, rowID) => {
    const {
      text_prop,
      deviceicon,
      checked,
      status,
      yincome,
      totalincome,
      devicename,
      realTime,
      sn,
    } = item;
    return (
      <li
        className={`${styles['list-item']} ${checked ? styles['checked'] : ''}`}
        key={rowID}
        onClick={() => handleItemClick(rowID, item)}
      >
        <div className={styles['img-box']}>
          <label className={styles['label']}>{text_prop}</label>
          <img className={styles['img']} src={deviceicon} alt="" />
        </div>
        <div className={styles['item-info']}>
          <h3
            className={`${styles['h3']} ${
              status === 1 ? styles['online'] : status === 0 ? 'offline' : 'error'
            }`}
          >
            {sn}
          </h3>
          <p className={styles['info-text']}>{devicename}</p>
          <p className={styles['info-text']}>
            {renderProvince(realTime)}&nbsp;{renderIsp(realTime)}&nbsp;
            {renderNat(realTime)}
          </p>
        </div>
        <div className={styles['income-info']}>
          <p className={styles['earn']}>+{yincome}</p>
          <p className={styles['total']}>总{totalincome}</p>
        </div>
      </li>
    );
  }, []);

  return (
    <ul className={`${styles['list']} ${choosen ? styles['choose'] : ''}`}>
      <ListView
        dataSource={dataSource}
        renderRow={row}
        useBodyScroll
        renderFooter={() => (
          <p style={{ textAlign: 'center' }}>{loading ? '加载中……' : '已加载全部~'}</p>
        )}
        onEndReached={() => {
          if (!allowPagination) return;
          getList(false);
        }}
        onEndReachedThreshold={60}
        initialListSize={pageSize}
        pageSize={pageSize}
      />
    </ul>
  );
};
export default DeviceList;
